import moment from "moment";
import momentJalali from "jalali-moment";

const getDateNowJalali = () => {
  return momentJalali().locale("fa").format("YYYY/M/D");
};

const getDateNow = () => {
  return moment().format();
};

const prepareDateString = (date) => {
  let dateSplit = date.replace("T", " ").split("+");
  return dateSplit[0];
};

const addStartTime = (dateString) => {
  return dateString + " 00:00:00";
};
const addEndTime = (dateString) => {
  return dateString + " 23:59:59";
};

const getLastDayDate = (dayNumber) => {
  return moment().subtract(dayNumber, "d").format("YYYY-MM-DD");
};

const convertJalaliToGregorian = (jalaliDate) => {
  return momentJalali
    .from(jalaliDate, "fa", "YYYY/MM/DD")
    .locale("en")
    .format("YYYY/MM/DD");
};
const convertGregorianToJalali = (gregorianDate, format = "YYYY/MM/DD") => {
  let date = momentJalali
    .from(gregorianDate, "en", "YYYY/MM/DD")
    .locale("fa")
    .format(format);
  return date.replace("آدینه", "جمعه");
};

const getDifferentDates = (dateFrom, dateTo) => {
  let differentDates = moment(dateFrom).diff(moment(dateTo), "days");
  if (differentDates < 0) {
    return -differentDates;
  }
  return differentDates;
};

const getDayNameFromDateString = (dateString, locale) => {
  const date = new Date(dateString);
  return date.toLocaleDateString(locale, { weekday: "long" });
};

const addDate = (date, number, typeAdd) => {
  return moment(date).add(number, typeAdd).format("YYYY-MM-DD HH:mm:ss");
};

export default {
  prepareDateString,
  addStartTime,
  addEndTime,
  getLastDayDate,
  getDateNow,
  getDateNowJalali,
  convertJalaliToGregorian,
  getDifferentDates,
  convertGregorianToJalali,
  getDayNameFromDateString,
  addDate,
};
